import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getEasyBuyFailure,
    getEasyBuyRequest,
    getEasyBuySuccess
} from './EasyBuySlice';
import i18next from 'i18next';
import { _BROTHER_PLUS_API_ENDPOINTS, LOCALSESSIONDATAKEYS, SUCCESS } from '../../constants/AppConstants';
import { _CALLGETAPI } from '../../api/apiHandler';
import { getLocalSessionData } from '../../utils/Authentication/handleUserSession';

function _GET_EASYBUY_DETAILS(model, isApplyBPlusNewDeviceDiscount) {
    const endpoint = _BROTHER_PLUS_API_ENDPOINTS.GET_PRINTER_SUPPLIES;
    const payload = {
        params: {
            model: model,
            isApplyNewDeviceDiscount: isApplyBPlusNewDeviceDiscount ?? false
        }
    };
    return _CALLGETAPI(endpoint, payload)
        .then(response => response)
        .catch(error => { throw error });
}

function* getEasyBuySaga(action) {
    try {
        const model = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
        const isApplyBPlusNewDeviceDiscount = action.payload.isApplyBPlusNewDeviceDiscount
        if (model) {
            const easyBuyData = yield call(_GET_EASYBUY_DETAILS, model, isApplyBPlusNewDeviceDiscount);
            if (easyBuyData?.actionStatus?.toUpperCase() === SUCCESS) {
                yield put(getEasyBuySuccess(easyBuyData));
            } else {
                yield put(getEasyBuyFailure(i18next.t('ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR')));
            }
        }
    }
    catch (error) {
        yield put(getEasyBuyFailure(error.message));
    }


}

export default function* watchGetEasyBuyService() {
    yield takeEvery(getEasyBuyRequest.type, getEasyBuySaga);
}
